export var BenefitCategory;
(function (BenefitCategory) {
    BenefitCategory["PROMOTION"] = "PROMOTION";
    BenefitCategory["PRODUCT"] = "PRODUCT";
    BenefitCategory["GIFT"] = "GIFT";
    BenefitCategory["SERVICE"] = "SERVICE";
    BenefitCategory["ENGAGEMENT"] = "ENGAGEMENT";
})(BenefitCategory || (BenefitCategory = {}));
export var BenefitStatus;
(function (BenefitStatus) {
    BenefitStatus["AVAILABLE"] = "AVAILABLE";
    BenefitStatus["BOOKED"] = "BOOKED";
    BenefitStatus["EXPIRED"] = "EXPIRED";
    BenefitStatus["FREEZED"] = "LOCKED";
    BenefitStatus["NEW"] = "NEW";
    BenefitStatus["USED"] = "USED";
})(BenefitStatus || (BenefitStatus = {}));
export var RedemptionRule;
(function (RedemptionRule) {
    RedemptionRule["CLICK_ON_CTA"] = "CLICK_ON_CTA";
    RedemptionRule["CUSTOMER_REQUEST"] = "CUSTOMER_REQUEST";
    RedemptionRule["PRODUCT_CODE"] = "PRODUCT_CODE";
    RedemptionRule["PROMO_CODE"] = "PROMO_CODE";
})(RedemptionRule || (RedemptionRule = {}));
//# sourceMappingURL=benefits.types.js.map